import helpSectionConstants from "./constants"
import actions from "../../actions"

const initialState = {
	helpTags   : [],
	helps      : [],
	help       : null,
	isSending  : false,
	error      : null,
	tagChanged : null
}

export default function (state = initialState, action){
	switch (action.type){
		case helpSectionConstants.GET_HELPS.REQUEST:
		case helpSectionConstants.UPDATE_HELP_TAG.REQUEST:
		case helpSectionConstants.CREATE_HELP_TAG.REQUEST:
		case helpSectionConstants.DELETE_HELP_TAG.REQUEST:
		case helpSectionConstants.RESTORE_HELP_TAG.REQUEST:
		case helpSectionConstants.CREATE_HELP.REQUEST:
		case helpSectionConstants.DELETE_HELP.REQUEST:
		case helpSectionConstants.UPDATE_HELP.REQUEST:
		case helpSectionConstants.RESTORE_HELP.REQUEST:
		case helpSectionConstants.GET_ONE_HELP.REQUEST:
			return {
				...state,
				isSending: true
			}
		case helpSectionConstants.GET_HELP_TAGS.REQUEST:
			return {
				...state,
				isSending  : true,
				tagChanged : null
			}
		case helpSectionConstants.GET_HELPS.FAILURE:
		case helpSectionConstants.GET_HELP_TAGS.FAILURE:
		case helpSectionConstants.UPDATE_HELP_TAG.FAILURE:
		case helpSectionConstants.CREATE_HELP_TAG.FAILURE:
		case helpSectionConstants.DELETE_HELP_TAG.FAILURE:
		case helpSectionConstants.RESTORE_HELP_TAG.FAILURE:
		case helpSectionConstants.CREATE_HELP.FAILURE:
		case helpSectionConstants.DELETE_HELP.FAILURE:
		case helpSectionConstants.UPDATE_HELP.FAILURE:
		case helpSectionConstants.RESTORE_HELP.FAILURE:
		case helpSectionConstants.GET_ONE_HELP.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case helpSectionConstants.GET_HELPS.SUCCESS:
			return {
				...state,
				isSending : false,
				helps     : action.payload.result
			}
		case helpSectionConstants.GET_HELP_TAGS.SUCCESS:
			return {
				...state,
				isSending : false,
				helpTags  : action.payload.result
			}
		case helpSectionConstants.RESTORE_HELP_TAG.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.restore : null
			}
		case helpSectionConstants.UPDATE_HELP_TAG.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.update : null
			}
		case helpSectionConstants.CREATE_HELP_TAG.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.create : null
			}
		case helpSectionConstants.CREATE_HELP.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.create : null
			}
		case helpSectionConstants.DELETE_HELP.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.delete : null
			}
		case helpSectionConstants.DELETE_HELP_TAG.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.delete : null
			}
		case helpSectionConstants.UPDATE_HELP.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.update : null
			}
		case helpSectionConstants.RESTORE_HELP.SUCCESS:
			return {
				...state,
				isSending  : false,
				tagChanged : action.payload.result ? actions.restore : null
			}
		case helpSectionConstants.GET_ONE_HELP.SUCCESS:
			return {
				...state,
				isSending : false,
				help      : action.payload.result
			}
		case helpSectionConstants.CLEAR: {
			return {
				...state,
				helpTags   : [],
				helps      : [],
				help       : null,
				isSending  : false,
				error      : null,
				tagChanged : null
			}
		}
		default:
			return {
				...state
			}
	}
}